import ApolloClient from "apollo-client";
import { IGrape } from "../grape_gql_interface";
import { IUser } from "../User";

export abstract class GrapesPlugin {
  abstract onInvoked(grape: IGrape, user: IUser, client: ApolloClient<any>): void;
}
